module.exports = __webpack_public_path__ + "static/media/emeka-img.34c99b0e.jpeg";